import { view, hdrm } from '@yola/ws-sdk';
import { SubmitActionsGenerationContract } from 'src/js/modules/element-settings/helpers/stage-contracts';
import mediaTypeIds from '../constants/media-type-ids';
import mediaContainerBuilder from './media-container-builder';

const createSubmitActionsIframeHandler =
  ({ mediaContainerElement }) =>
  (flowData, context) => {
    const targetElementId = view.accessors.getLiveElementId(mediaContainerElement);
    const targetStaticElement = view.accessors.getStaticElement(targetElementId);
    const newMediaContainerElement = targetStaticElement.cloneNode(true);

    const fieldsValues = {
      ...context.getFieldsValues(),
      ...flowData?.modifiedFieldsValues,
    };

    mediaContainerBuilder.replaceContentFromFieldsValues(
      newMediaContainerElement,
      mediaTypeIds.VIDEO,
      fieldsValues
    );

    return SubmitActionsGenerationContract.create([
      view.actions.replaceElement(newMediaContainerElement, targetElementId, {
        strategy: hdrm.constants.updateStrategies.UPDATE_BOTH,
      }),
    ]);
  };

export default createSubmitActionsIframeHandler;
